import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./CastAndCrew.css";
import Footer from "../Footer/Footer";
import HttpApis from "../../services/HttpApis";

const CastAndCrew = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [credits, setCredits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await HttpApis.getCastAndCrew(id);
        const data = res?.data ?? res;
        if (data?.status === "success") {
          setMember(data.data.member);
          const filtered = data.data.credits.filter((c) => c.content !== null);
          const seen = new Set();
          const unique = filtered.filter((c) => {
            const isSeason = c.content?.content_type === "Season";
            const key = isSeason
              ? `series_${c.content?.series_id}`
              : `movie_${c.content_id}`;

            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          setCredits(unique);
        } else {
          setError("Failed to load cast member.");
        }
      } catch (err) {
        setError("Something went wrong.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const formatDob = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const handleDetails = (slug, type) => {
    navigate(`/details/${type}/${slug}`);
  };

  if (loading) {
    return (
      <div className="cast">
        <div className="cast__loader">Loading...</div>
        <Footer />
      </div>
    );
  }

  if (error || !member) {
    return (
      <div className="cast">
        <div className="cast__error">{error || "No data found."}</div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cast" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div className="cast__container" style={{ flex: 1 }}>

        <div className="cast__profile-card">

          {/* Profile Header */}
          <div className="cast__profile-header">
            {member.image_url ? (
              <img
                className="cast__avatar"
                src={member.image_url}
                alt={member.name}
              />
            ) : (
              <div className="cast__avatar cast__avatar--placeholder">
                {getInitials(member.name)}
              </div>
            )}
            <div className="cast__profile-info">
              <h2 className="cast__name">{member.name}</h2>
              <span className="cast__dob-label">Date of Birth</span>
              <span className="cast__dob">{formatDob(member.dob)}</span>
            </div>
          </div>

          <div className="cast__divider" />

          <p className="cast__bio cast__bio--clamp">{member.bio}</p>

          <div className="cast__divider" />

          {/* Filmography */}
          <div className="cast__filmography">
            <h3 className="cast__filmography-title">Filmography</h3>
            {credits.length > 0 ? (
              <div className="cast__film-grid">
                {credits.map((credit) => (
                  <div
                    key={credit.id}
                    className="cast__film-card"
                    onClick={() => {
                      const typeSlug = credit.content.content_type
                        ? credit.content.content_type.toLowerCase().replace(/\s+/g, "-")
                        : "movie";
                      handleDetails(credit.content.slug, typeSlug);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="cast__film-thumb">
                      <img
                        src={credit.content.landscape}
                        alt={credit.content.name}
                        className="cast__film-img"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "flex";
                        }}
                      />
                      <div
                        className="cast__film-fallback"
                        style={{ display: "none" }}
                      >
                        <span className="cast__film-fallback-text">
                          {credit.content.name}
                        </span>
                      </div>

                      {/* Hover overlay with title */}
                      <div className="search-hover-overlay">
                        <div className="search-overlay-content">
                          <p className="search-overlay-title">{credit.content.name}</p>
                        </div>
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="cast__no-data">No Data Available</p>
            )}
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CastAndCrew;